import React, { useState} from 'react'
import PlayerSelector from '../player-selector'
import { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'

export default function GameWaitingPlayers({reservationId, waitingPlayers, expanded, onCreateWaitingPlayer, onRemoveWaitingPlayer, playerRefresh}) {
  const [playerParams, setPlayerParams] = useState({})

  const createWaitingPlayer = (e) => {
    e.preventDefault()
    e.target.blur()
    if (playerParams) onCreateWaitingPlayer(playerParams)
  }

  if ((!waitingPlayers || waitingPlayers.length === 0) && !expanded) return <div>Waitlist disabled</div>

  const formattedPhone = player => {
    return player.country_code && player.country_code.toLowerCase() != 'us' ? formatPhoneNumberIntl(player.phone) : formatPhoneNumber(player.phone)
  }

  return <div>
    { expanded &&
      <div className='add-player-container'>
        <form>
          Add new Player
          <div className='row'>
            <div className='col-xs-10'>
              <PlayerSelector
                disableNewOption
                reservationId={reservationId}
                onChange={(params) => setPlayerParams({...playerParams, ...params})}
                refresh={playerRefresh}
              />
            </div>
            <div className='col-xs-2'>
              <button className='btn btn-success' onClick={createWaitingPlayer}>Add +</button>
            </div>
          </div>
        </form>
      </div>
    }
    { waitingPlayers &&
      <table className='table table-striped text-center table-transference'>
        <tbody>
        {
          waitingPlayers.map(player => {
            return <tr key={player.id}>
              <td>{player.name}</td>
              <td>{formattedPhone(player)}</td>
              <td className='td-transference'>
                <a className='btn btn-danger' onClick={(e) => onRemoveWaitingPlayer(player.id)}>
                  <i className='fa fa-trash-o'></i>
                </a>
              </td>
            </tr>
          })
        }
        </tbody>
      </table>
    }
  </div>
}
